import React from 'react';

import { Title } from 'components/typography';

import { marketIntro, introText } from './scss/MarketCharts.module.scss';

const MarketChartsIntro = () => {
  return (
    <div className={marketIntro}>
      <Title
        size="xl"
        value={
          <span>
            {'commodities market'}
            <br className="d-none d-md-block" />
            {' monitor'}
          </span>
        }
      />
      <div className={introText}>
        The commodities market monitor is a real time view of price movements
        for the commodities available for trade through the Exchange's trading
        platform. Access to historical price data can be obtained by subscribing
        for our market research package here.
      </div>
    </div>
  );
};

export default MarketChartsIntro;
